import { t } from "../../validation/validator";
import { stripeCouponSchema } from "./stripeCoupon.schemas";

export const stripeDiscountSchema = t.type({
  id: t.string,
  coupon: t.union([stripeCouponSchema, t.null]),
  start: t.number,
  end: t.union([t.number, t.null]),
  subscription: t.string,
  subscription_item: t.union([t.string, t.null]),
  invoice: t.union([t.string, t.null]),
  invoice_item: t.union([t.string, t.null]),
  promotion_code: t.union([t.string, t.null]),
});
export type StripeDiscount = t.TypeOf<typeof stripeDiscountSchema>;
